import React from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    TextField,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    checked,
    Drawer,
    IconButton,
    Radio,
    RadioGroup,
    Checkbox,
    TableContainer
} from "@mui/material";
import { Close, ArrowBack } from '@mui/icons-material';
import { useState, useContext } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import { Bold, Import } from "lucide-react";
import { ReactComponent as UploadIcon } from "../../../images/uploadIcon.svg";
import { ReactComponent as WhiteUploadIcon } from "../../../images/WhiteUploadIcon.svg";
import { ReactComponent as NoDataIcon } from "../../../images/NoDataCapturedIcon.svg";
import { SearchIcon } from "lucide-react";
import { ReactComponent as DeleteIcon } from "../../../images/APIDeleteNewIcon.svg";
import { color } from "echarts";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import yaml from "js-yaml";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { useNavigate, useLocation } from "react-router-dom";
import { generateTestCasesForAPI, swaggerToPostman, APITraceabilityMatrix, endpoitnExtractionAPI, resourceChainTestCases } from "../../../services/webServices";
import MessagePopup from "../../popup-components/MessagePopup";
import { ReactComponent as UploadFileIcon } from "../../../images/uploadedFileIcon.svg";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI.js";
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import { ReactComponent as DownloadIcon } from "../../../images/TraceabilityDownloadIcon.svg";
import { htmlParsingForSwagger } from "../../../services/webServices";
import { ReactComponent as GenerateButtonIcon } from "../../../images/GenerateApiDocIcon.svg";




function ImportSwaggerURL() {


    const navigate = useNavigate();
    const location = useLocation();
    const { setLoadingState } = useContext(LoadingModalContext);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [FileContentEndpoints, setFileContentEndpoints] = useState([]);
    const [traceabilityMatrixData, setTraceabilityMatrixData] = useState({});
    const [apiurl, setApiUrl] = useState("");
    const [responseParsedData, setResponseParsedData] = useState(null);
    const [openAPISpec, setOpenAPISpec] = useState(null);
    const [openAPIDocPopup, setOpenAPIDocPopup] = useState(false);
    const [authoType, setAuthoType] = useState("none");
    const [credentials, setCredentials] = useState("");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectionMode, setSelectionMode] = useState('choose'); // 'choose' or 'all'
    const [selectedTestCases, setSelectedTestCases] = useState([]);
    const [search, setSearch] = useState("");



    function flattenPostmanItems(items) {
        const flat = [];

        function recurse(subItems) {
            subItems.forEach(item => {
                if (item.request) {
                    flat.push(item); // it's a request
                } else if (item.item && item.item.length > 0) {
                    recurse(item.item); // it's a folder
                }
            });
        }

        recurse(items);
        return flat;
    }

    const renderInputData = (inputData) => {
        if (!inputData || Object.keys(inputData).length === 0) {
            return "-";
        }
        if (typeof inputData === 'object') {
            return JSON.stringify(inputData, null, 2);
        }
        return inputData;
    };


    const extractEndpoints = (openApiSpec) => {
        if (!openApiSpec.paths) return [];

        const endpoints = [];

        Object.entries(openApiSpec.paths).forEach(([path, methods]) => {
            Object.entries(methods).forEach(([method, details]) => {
                endpoints.push({
                    method: method.toUpperCase(),
                    endpoint: path,
                    params: details.parameters
                        ? details.parameters.map((p) => p.name).join(", ")
                        : "-",
                    headers: details.responses?.["200"]?.content
                        ? Object.keys(details.responses["200"].content).join("/n")
                        : "-",
                    authType: details.security
                        ? details.security.flatMap(sec => Object.keys(sec)).join(", ")
                        : "-"


                });
            });
        });

        return endpoints;
    };

    const filteredRows = FileContentEndpoints?.filter((row) =>

        Object.values(row).some((val) =>
            (val?.toString() ?? '').toLowerCase().includes(search.toLowerCase())
        )
    );

    const handleGenerateOpenAPISpec = async () => {
        let progressHandler;
        try {
            progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 9000 });
            progressHandler.start("Generating API Document");
            const response = await htmlParsingForSwagger({ url: apiurl });

            if (response && response.data) {
                setResponseParsedData(response.data);
                setOpenAPISpec(response.data.spec);
                setOpenAPIDocPopup(true)
                // const endpoints = extractEndpoints(response.data.spec);
                // setFileContentEndpoints(endpoints);

            }
            progressHandler.updateMessage("Extracting Endpoints")


            const responseData = await swaggerToPostman(response.data.spec);

            if (responseData.data.item) {
                const flattenedItems = flattenPostmanItems(responseData.data.item);

                const batchSize = 3;
                const batches = [];
                const endpointsyaml = [];

                // Create batches
                for (let i = 0; i < flattenedItems.length; i += batchSize) {
                    batches.push(flattenedItems.slice(i, i + batchSize));
                }

                const promises = batches.map(async (batch, batchIndex) => {
                    try {
                        // Fixed typo: endpoitnExtractionAPI -> endpointExtractionAPI
                        const testcasesresponse = await endpoitnExtractionAPI({ item: batch });

                        if (testcasesresponse.data && testcasesresponse.data) {

                            // Return the actual data instead of empty array
                            return testcasesresponse.data;
                        }

                    } catch (error) {
                        console.error(
                            error?.response?.data?.error || error.message,
                            "Error processing batch:", batchIndex
                        );
                    }
                    return []; // Return empty array if no data or error
                });

                const results = await Promise.allSettled(promises);

                // Fixed: Access the fulfilled value correctly
                results.forEach((result) => {
                    if (result.status === "fulfilled" && result.value) {
                        // If result.value is an array, spread it; if it's an object, push it
                        if (Array.isArray(result.value)) {
                            endpointsyaml.push(...result.value);
                        } else {
                            endpointsyaml.push(result.value);
                        }
                    } else if (result.status === "rejected") {
                        console.error("One call failed:", result.reason);
                    }
                });

                if (endpointsyaml && endpointsyaml.length > 0) {

                    setFileContentEndpoints(endpointsyaml);
                }

            }

            await progressHandler.finishAndClose();


        } catch (error) {
            console.error("Error generating OpenAPI spec:", error);
            setLoadingState({ open: false, message: "", progress: null });
            setPopupMessage("Error generating OpenAPI spec. Please check the API URL and try again.");
            setPopupOpen(true);
        } finally {

            if (progressHandler) {
                progressHandler.stop();
            }
            setLoadingState({ open: false, message: "", progress: null });
        }
    }

    const functionalTestCases = [
        { id: 'Positive test case', label: 'Positive test cases' },
        { id: 'Negative test case', label: 'Negative test cases' },
        { id: 'Error Handling test case', label: 'Error handling test cases' },
        { id: 'Boundary test case', label: 'Boundary test cases' },
        { id: 'Resource Chain test case', label: 'End-End testing(Resource-Chain)' },

    ];

    const nonFunctionalTestCases = [
        { id: 'Performance test case', label: 'Performance test cases' },
        { id: 'Security test case', label: 'Security test cases' },

    ];

    const handleTestCaseToggle = (testCaseId) => {
        setSelectedTestCases(prev =>
            prev.includes(testCaseId)
                ? prev.filter(id => id !== testCaseId)
                : [...prev, testCaseId]
        );
    };

    const handleSelectionModeChange = (event) => {
        setSelectionMode(event.target.value);
        if (event.target.value === 'all') {
            setSelectedTestCases([]);
        }
    };



    const handleBack = () => {
        setSelectedTestCases([]);
        setSelectionMode('choose');
        setDrawerOpen(false)
    };

    const handleShowCatergory = () => {
        setDrawerOpen(true);
    }




    const handleGenerateTestCases = async () => {



        const testCasesToGenerate = selectionMode === 'all'
            ? [
                "Positive test case", "Negative test case", "Boundary test case", "Error Handling test case",
                "Security test case", "Performance test case", "Resource Chain test case"]
            : selectedTestCases;

        let progressHandler;
        try {
            let tcCounter = 1;
            const finalArray = [];
            let traceabilityMatrix = null;
            // const responseParsedData = await htmlParsingForSwagger({ url: apiurl });
            // if (responseParsedData && responseParsedData.data) {
            //   console.log("Parsed Data:", responseParsedData.data);
            //   // Handle the parsed data as needed
            //   setOpenAPISpec(responseParsedData.data.spec);
            progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 420000 })

            const isOnlyResourceChain =
                selectedTestCases.length === 1 &&
                selectedTestCases.includes("Resource Chain test case");

            if (isOnlyResourceChain) {
                // Only call resourceChainTestCases API and skip all others
                progressHandler.updateMessage("Generating Resource Chain Test Cases");

                const resourceChainResponse = await resourceChainTestCases({
                    endpoints: openAPISpec,
                });

                if (resourceChainResponse?.data?.length > 0) {
                    finalArray.push(...resourceChainResponse.data);
                } else {
                    console.warn(" No Resource Chain Test Cases generated");
                }

                await progressHandler.finishAndClose();

                // Navigate to display page with only resource chain test cases
                if (finalArray.length > 0) {
                    navigate("/dashboard/api-testing/test-cases-display", {
                        state: {
                            ...location.state,
                            generateTestCasesData: finalArray,
                            apiDocData: openAPISpec || null,
                            button: "importSwaggerURL",
                            testCasesToGenerate: testCasesToGenerate,
                        },
                    });
                }
                return;
            }


            const responsePostmanCollection = await swaggerToPostman(openAPISpec);
            if (responsePostmanCollection.data.item) {
                const flattenedItems = flattenPostmanItems(responsePostmanCollection.data.item);
                if (flattenedItems.length == 1) {
                    progressHandler.start("Generating Test Cases");
                }
                else {
                    progressHandler.start("Generating test cases from API endpoints");
                }

                const promises = flattenedItems.map(async (item, index) => {
                    progressHandler.updateMessage(`Generating test cases from API endpoints`);
                    try {
                        const testcasesresponse = await generateTestCasesForAPI({ item: item, testCasesToGenerate: testCasesToGenerate });

                        if (testcasesresponse.data && testcasesresponse.data.testcases) {

                            return testcasesresponse.data.testcases;

                        }
                    } catch (error) {
                        console.error(
                            error?.response?.data?.error || error.message,
                            "Error processing swagger item:", index
                        );
                    }
                    return [];
                }
                );
                const results = await Promise.allSettled(promises);
                for (const result of results) {
                    if (result.status === "fulfilled" && Array.isArray(result.value)) {
                        const updated = result.value.map((testcase) => {
                            const isFunctional = testcase.Category?.toLowerCase() === "functional testing";
                            const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";

                            let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
                            let shortCode = "";

                            if (subCategory.includes("positive")) shortCode = "POS";
                            else if (subCategory.includes("negative")) shortCode = "NEG";
                            else if (subCategory.includes("boundary")) shortCode = "BOUND";
                            else if (subCategory.includes("error")) shortCode = "ERR";
                            else if (subCategory.includes("security")) shortCode = "SEC";
                            else if (subCategory.includes("performance")) shortCode = "PERF";

                            const padded = String(tcCounter).padStart(2, "0");
                            const id = `${prefix}_${padded}_${shortCode}`;
                            tcCounter++;

                            return {
                                ...testcase,
                                "Test Case ID": id,
                            };
                        });

                        finalArray.push(...updated);
                    }
                }
                if (selectedTestCases.includes("Resource Chain test case") || selectionMode === "all") {
                    progressHandler.updateMessage("Generating Resource Chain Test Cases");

                    try {
                        const resourceChainResponse = await resourceChainTestCases({
                            endpoints: openAPISpec,
                        });

                        if (resourceChainResponse?.data?.length) {
                            finalArray.push(...resourceChainResponse.data);
                        }
                    } catch (chainError) {
                        console.error("error generating resource chain test cases:", chainError.message);
                    }

                }


                // const filteredTestCases = finalArray.map((testcase) => ({
                //     "Test Case ID": testcase["Test Case ID"],
                //     "API Endpoint": testcase["API Endpoint"],
                //     "Method": testcase["Method"],
                //     "Test Description": testcase["Test Description"],
                //     "Category": testcase["Category"],
                // }));

                // try {
                //     progressHandler.updateMessage("Generating Traceability Matrix");
                //     const response = await APITraceabilityMatrix(filteredTestCases);
                //     if (response.data !== null) {
                //         traceabilityMatrix = response.data;
                //     }
                // } catch (error) {
                //     console.log(
                //         error?.response?.data?.error || error.message,
                //         "Error generating traceability matrix"
                //     );
                //     setPopupMessage("Error generating traceability matrix. Please try again.");
                //     setPopupOpen(true);
                // }

                await progressHandler.finishAndClose();
                navigate("/dashboard/api-testing/test-cases-display", {
                    state: {
                        ...location.state,
                        generateTestCasesData: finalArray,
                        apiDocData: openAPISpec || null,
                        button: "urlHTMLSwaggerParser",
                        testCasesToGenerate: testCasesToGenerate


                    },
                });


            }
        } catch (error) {
            console.error("Error generating test cases:", error);
            setLoadingState({ open: false, message: "", progress: null });
            setPopupMessage("Something went wrong while generating test cases.");
            setPopupOpen(true);
        } finally {

            if (progressHandler) {
                progressHandler.stop();
                setLoadingState({ open: false, message: "", progress: null });
            }
        }
    }

    const handleDownloadAPIDocument = (openAPISpec) => {
        if (!openAPISpec) return;

        try {
            const yamlString = yaml.dump(openAPISpec);
            const blob = new Blob([yamlString], { type: "text/yaml" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "openapi-document.yaml";
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error converting OpenAPI document to YAML:", error);
            setPopupMessage("Error downloading document");
            setPopupOpen(true)
        }
    };



    return (
        <Box
            sx={{
                p: 2,
                bgcolor: "#F6F3F2",
                display: "flex",
                flexDirection: "column",
                height: "100%",      // fill whatever space parent gave
                maxHeight: "100%",   // don’t exceed it
                minHeight: 0,        // <-- key: allows child to shrink for scrolling
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    // height: { xs: "60vh", sm: "65vh", md: "73vh" }, // 
                    overflowY: "scroll", // scrolling works
                    scrollbarWidth: "none", // Firefox
                    "&::-webkit-scrollbar": {
                        display: "none", // Chrome, Safari, Edge
                    },  // adds scroll if content is taller
                    // mx: "auto",
                    mb: 2
                }}
            >
                <Box sx={{ justifyContent: "space-between", display: "flex", gap: 2 }}>
                    <Card
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            p: 3,
                            flex: 1,
                            mb: 3,
                            border: "none",
                            backgroundColor: "#fff",


                        }}
                    >
                        <Typography variant="Subtitle1" fontWeight="bold" fontSize={17}>Import Swagger URL</Typography>
                        {/* Upload Specifications Section */}

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1.5 }}>

                            Connect directly to your API's Swagger/OpenAPI endpoint for real-time specification analysis </Typography>
                        <TextField
                            label="API Specification URL"
                            variant="outlined"
                            fullWidth
                            value={apiurl}
                            onChange={(e) => setApiUrl(e.target.value)}
                            placeholder="https://api.example.com/swagger.json"
                            sx={{ mb: 3 }}
                        >

                        </TextField>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
                            <FormControl fullWidth>
                                <InputLabel >Authentication Type</InputLabel>
                                <Select
                                    label="Authentication Type"
                                    placeholder="Select Auth Type"
                                    defaultValue="none"
                                    value={authoType}
                                    onChange={(e) => setAuthoType(e.target.value)}
                                >
                                    <MenuItem value="none">None</MenuItem>
                                    <MenuItem value="apiKey">API Key</MenuItem>
                                    <MenuItem value="oauth2">OAuth 2.0</MenuItem>
                                    <MenuItem value="basic">Basic Auth</MenuItem>

                                </Select>
                            </FormControl>


                            <TextField
                                label="Credentials"
                                fullWidth
                                placeholder="Enter credentials"
                                disabled={authoType === "none"}
                                value={credentials}
                                onChange={(e) => setCredentials(e.target.value)}
                            >

                            </TextField>
                        </Box>
                        <Box sx={{ display: "flex", gap: 2 }}>

                            <Button variant="outlined" startIcon={<GenerateButtonIcon />} sx={{
                                borderRadius: "6px", color: "#0094FB", borderColor: " #0094FB",
                                borderWidth: "2px",
                                fontWeight: "bold", textTransform: "none",

                            }}
                                onClick={handleGenerateOpenAPISpec}
                            >
                                Generate API Document
                            </Button>

                            <Button variant="outlined" startIcon={<DownloadIcon />} sx={{
                                borderRadius: "6px", color: "#0094FB", borderColor: " #0094FB",
                                borderWidth: "2px",
                                fontWeight: "bold", textTransform: "none",

                            }}
                                disabled={!openAPISpec}
                                onClick={() => handleDownloadAPIDocument(openAPISpec)}
                            >

                                Download API Document
                            </Button>

                        </Box>

                    </Card>

                </Box>

                {/* Captured API Endpoints */}
                <Box  >
                    <Card
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            p: 2,
                            mb: 3,
                            border: "none"
                        }}
                    >
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 30 }} >
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, fontSize: 17 }}>
                                Captured API Endpoints
                            </Typography>
                            <TextField
                                InputProps={{
                                    startAdornment: (
                                        <SearchIcon style={{ color: "#a9a9a9", marginRight: 8 }} />
                                    ),
                                }}
                                placeholder="Search by endpoint"
                                variant="outlined"

                                size="small"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}

                                sx={{ mb: 2, width: 500 }}
                            />
                        </Box>
                        {/* <Divider sx={{ mb: 2 }} /> */}

                        {/* Empty State */}
                        <Box
                            sx={{
                                textAlign: "center",
                                py: 3,
                                color: "text.secondary",
                                minHeight: 200,
                                overflowX: "auto",
                                overflowY: "auto",

                            }}

                        >
                            {/* <NoDataIcon /> */}

                            {FileContentEndpoints && FileContentEndpoints.length > 0 ? (
                                <TableContainer sx={{ maxHeight: 500 }}>
                                    <Table stickyHeader sx={{ border: '1px solid #e0e0e0', borderLeft: 'none', borderRight: 'none' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><b>HTTP Method</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                                <TableCell><b>Endpoint</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                                <TableCell><b>Param Type</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                                <TableCell><b>Params</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                                <TableCell><b>Headers</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                                <TableCell><b>Auth Type</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                                <TableCell><b>Body</b>
                                                    <ArrowDownwardOutlinedIcon sx={{
                                                        fontSize: "medium", ml: 0.3, position: "relative",
                                                        top: "3px"
                                                    }} />
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredRows.map((row, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell sx={{ minWidth: 200 }}>{row.method}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row.path}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row.paramType || "-"}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{renderInputData(row.params)}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{renderInputData(row.headers)}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row.authType}</TableCell>
                                                    <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{renderInputData(row.body)}</TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                <Box textAlign="center" py={6} color="text.secondary">
                                    <NoDataIcon />
                                </Box>
                            )}


                        </Box>
                    </Card>
                </Box>

            </Box>

            {/* Bottom Buttons */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button variant="outlined" sx={{
                    borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                    borderWidth: "2px",   // makes border bold
                    fontWeight: "bold", textTransform: "none",
                    padding: "4px 16px"
                }}
                    onClick={() => navigate("/dashboard/api-testing/landingpage")}

                >

                    <ArrowBackIcon style={{ marginRight: 6, fontSize: 18 }} />
                    Back
                </Button>
                <Button
                    variant="contained"
                    sx={{
                        borderRadius: "8px",
                        backgroundColor: "#0094FB",
                        textTransform: "none",
                        fontWeight: "bold",
                        padding: "4px 16px"
                    }}

                    disabled={!openAPISpec}
                    onClick={handleShowCatergory}

                >
                    Generate test cases
                    <ArrowForwardIcon style={{ marginLeft: 8, fontSize: 18 }} />
                </Button>
            </Box>
            <MessagePopup
                modalOpen={popupOpen}
                message={popupMessage}
                okayHandler={() => setPopupOpen(false)}
            />
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                PaperProps={{
                    sx: {
                        width: "40%",
                        bgcolor: '#f8f9fa'
                    }
                }}
            >
                <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', minHeight: "100vh" }}>
                    {/* Header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <IconButton onClick={handleBack} sx={{ mr: 1, p: 0.5 }}>
                            <ArrowBack />
                        </IconButton>
                        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
                            Test Case Selection
                        </Typography>
                        <IconButton onClick={() => setDrawerOpen(false)} sx={{ p: 0.5 }}>
                            <Close />
                        </IconButton>
                    </Box>

                    {/* Selection Options */}
                    <Box sx={{ mb: 1, flex: 1 }}>
                        <RadioGroup
                            value={selectionMode}
                            onChange={handleSelectionModeChange}
                        >
                            <FormControlLabel
                                value="choose"
                                control={<Radio />}
                                label={
                                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                                        Choose test cases to be generated
                                    </Typography>
                                }
                                sx={{ mb: 1 }}
                            />

                            {selectionMode === 'choose' && (
                                <Box sx={{ ml: 4, mb: 1 }}>
                                    {/* Functional Test Cases */}
                                    <Typography variant="subtitle2" sx={{ mb: 1, color: 'black', fontWeight: 550, fontSize: 14 }}>
                                        Functional Test Cases
                                    </Typography>
                                    <Box sx={{ mb: 2, display: "flex", flexDirection: "column" }}>
                                        {functionalTestCases.map((testCase) => (
                                            <FormControlLabel
                                                key={testCase.id}
                                                control={
                                                    <Checkbox
                                                        checked={selectedTestCases.includes(testCase.id)}
                                                        onChange={() => handleTestCaseToggle(testCase.id)}
                                                        size="small"
                                                    />
                                                }
                                                label={
                                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                        {testCase.label}
                                                    </Typography>
                                                }
                                            // sx={{ mb: 1 }}
                                            />
                                        ))}
                                    </Box>

                                    {/* Non-Functional Test Cases */}
                                    <Typography variant="subtitle2" sx={{ mb: 1, color: 'black', fontWeight: 550, fontSize: 14 }}>
                                        Non-Functional Test Cases
                                    </Typography>
                                    <Box sx={{ mb: 1, display: "flex", flexDirection: "column" }}>
                                        {nonFunctionalTestCases.map((testCase) => (
                                            <FormControlLabel
                                                key={testCase.id}
                                                control={
                                                    <Checkbox
                                                        checked={selectedTestCases.includes(testCase.id)}
                                                        onChange={() => handleTestCaseToggle(testCase.id)}
                                                        size="small"
                                                    />
                                                }
                                                label={
                                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                        {testCase.label}
                                                    </Typography>
                                                }

                                            />
                                        ))}
                                    </Box>
                                </Box>
                            )}

                            <FormControlLabel
                                value="all"
                                control={<Radio />}
                                label={
                                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                                        Generate all test cases
                                    </Typography>
                                }
                            />
                        </RadioGroup>
                    </Box>

                    {/* Footer Buttons */}
                    <Box sx={{
                        display: "flex", justifyContent: "space-between",
                        gap: 2,
                        p: 2,



                    }}>
                        <Button
                            variant="outlined"
                            onClick={handleBack}
                            sx={{
                                borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                borderWidth: "2px",   // makes border bold
                                fontWeight: "bold", textTransform: "none",
                                padding: "5px 16px",
                                mb: 1,


                            }}
                        >
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleGenerateTestCases}
                            disabled={selectionMode === 'choose' && selectedTestCases.length === 0}
                            sx={{
                                borderRadius: "8px",
                                backgroundColor: "#0094FB",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "5px 16px",
                                mb: 1

                            }}
                        >
                            Confirm
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </Box>
    );
}

export default ImportSwaggerURL;